module.exports = __webpack_public_path__ + "img/nine_mobile_logo.53deed93.svg";